import SliderInput from "./slider-inputs";

class CustomVolume {

  private inputs = {
    posts: document.querySelector('input[name="calculator_posts"]') as HTMLInputElement,
    sources: document.querySelector('input[name="calculator_sources"]') as HTMLInputElement,
    private_sources: document.querySelector('input[name="calculator_private_sources"]') as HTMLInputElement,
  }
  private wrappers = {
    posts: document.querySelector('.custom-volume__slider-input-posts') as HTMLElement,
    sources: document.querySelector('.custom-volume__slider-input-sources') as HTMLElement,
    private_sources: document.querySelector('.custom-volume__slider-input-private-sources') as HTMLElement,
  }

  private totalPrice = document.querySelector('.custom-volume__total-price') as HTMLAnchorElement;

  constructor() {
    if(!this.inputs.posts || !this.inputs.sources || !this.inputs.private_sources || !this.totalPrice) return;
    this.init();
  }

  private calculateTotalPrice() {
    if (!this.inputs.posts || !this.inputs.sources || !this.inputs.private_sources || !this.totalPrice) return;

    const posts = parseInt(this.inputs.posts.value);
    const sources = parseInt(this.inputs.sources.value);
    const private_sources = parseInt(this.inputs.private_sources.value);
    const totalPrice = 15 * posts + 100 * sources + 250 * private_sources as number;
    const currencyString = this.totalPrice.dataset.currencyString;
    this.totalPrice.textContent = `${totalPrice.toString()} ${currencyString}`;
    this.totalPrice.href = `https://app.scribemate.io/?posts=${posts}&sources=${sources}&private-sources=${private_sources}`;
  }
  
  private createCustomSliders() {
    const postsInput = new SliderInput(this.wrappers.posts, {
      onTitleInputChange: (value: number) => {
        this.calculateTotalPrice();
      }
    });
    const sourcesInput = new SliderInput(this.wrappers.sources, {
      onTitleInputChange: (value: number) => {
        this.calculateTotalPrice();
      }
    });
    const privateSourcesInput = new SliderInput(this.wrappers.private_sources, {
      onTitleInputChange: (value: number) => {
        this.calculateTotalPrice();
      }
    });
  }

  private init() {
    this.createCustomSliders();
    this.calculateTotalPrice();
  }
}

export default function customVolume() {
  return new CustomVolume();
}

// Посты: мин 1 и макс 1000
// Источники: мин 1 и макс 100
// Закрытые источники: Источники: мин 1 и макс 100

// Цена в кнопке = 
// 15 руб * (Количество постов) +
// 100 руб * (Количество источников) +
// 250 руб * (Количество закрытых источников) +